import { AfterViewInit, Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { ProductDetailsMainSlider, ProductDetailsThumbSlider } from '../../../../shared/data/slider';
import { Product } from '../../../../shared/classes/product';
import { ProductService } from '../../../../shared/services/product.service';
import { SizeModalComponent } from "../../../../shared/components/modal/size-modal/size-modal.component";
import { IAddBaseItem, IBaseItem, IUsaProduct } from 'src/app/shared/Models/TopCollectionProduct';
import { Observable, Subscription } from 'rxjs';
import { HomeService } from 'src/app/shared/services/home.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IExtendPagination } from 'src/app/shared/Pagination/IPagination';
import { AuthService } from 'src/app/shared/services/account.service';
import { IUser } from 'src/app/shared/Models/IUser';
import { IColor, IColorWithSize, IProductVariation } from 'src/app/shared/Models/IProductVariation';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-product-left-sidebar',
  templateUrl: './product-left-sidebar.component.html',
  styleUrls: ['./product-left-sidebar.component.scss']
})
export class ProductLeftSidebarComponent implements OnInit {



  public product: Product = {};
  public counter: number = 1;
  public activeSlide: any = 0;
  public selectedSize: any;
  public mobileSidebar: boolean = false;

  noColor = false;
  noSize = false;
  usaProduct$: Observable<IUsaProduct>;

  usaProducts$: Observable<IUsaProduct[]>;
  usaProducts: IUsaProduct[] = [];
  saleProducts$: Observable<IUsaProduct[]>;
  saleProducts: IUsaProduct[] = [];
  urlSafe: SafeResourceUrl;
  isHasYoutubeLink = false;
  uniqSize: any[] = []

  routerSubscription: Subscription;
  isWholeSaleAccount = 'False';
  currentBarcodeInAddressBar = '';
  currentColor = '';
  colorWithSizes: IColorWithSize[] = [];
  public ProductDetailsMainSliderConfig: any = ProductDetailsMainSlider;
  public ProductDetailsThumbConfig: any = ProductDetailsThumbSlider;




  constructor(private route: ActivatedRoute,
    private _router: Router,
    private _homeService: HomeService,
    private sanitizer: DomSanitizer,
    private _authService: AuthService,
    public productService: ProductService) {

    var user: IUser = JSON.parse(localStorage.getItem('user'));
    if (user) {
      this.isWholeSaleAccount = user.isWholeSaleAccount.toString();
    }
    this.currentBarcodeInAddressBar = this.route.snapshot.paramMap.get('barcode');


    this.usaProduct$ = this._homeService.getTopCollectionById$;
    this.usaProduct$.subscribe(data => {




      this.uniqSize = [];
      var productVariations = data.productVariations;
      if (!productVariations) {
        return;
      }
      for (let i = 0; i < productVariations.length; i++) {
        const elements = productVariations[i].indexProductColorChildrenSizeDtos;

        for (let j = 0; j < elements.length; j++) {
          const element = elements[j];
          debugger
          if (element.childColorName == 'NoColor') {
            this.noColor = true;
          }
          if (this.currentBarcodeInAddressBar == element.childBarcode) {
            this.currentColor = element.childColorName;
            this.activeSlide = i;
            break
          }
        }

        for (let i = 0; i < elements.length; i++) {
          const element = elements[i];
          if (this.currentColor == element.childColorName) {
            if (element.sizeName == 'NoSize') {
              this.noSize = true;
            }
            this.uniqSize.push({
              sizeName: element.sizeName,
              barcode: element.childBarcode,
              color: element.childColorName

            })
          }


        }
      }
    })



  }



  ngOnInit(): void {


    this.saleProducts$ = this._homeService.getSaleProducts$;
    this.saleProducts$.subscribe((products) => {
      this.saleProducts = products;
    })
    this.usaProduct$ = this._homeService.getTopCollectionById$;
    this.usaProduct$.subscribe(data => {


      let isYoutubeNull = data.youtube;

      if (isYoutubeNull != "null" && isYoutubeNull != null) {
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(data.youtube);
        this.isHasYoutubeLink = true;
      } else {
        this.isHasYoutubeLink = false;
      }
      document.body.scrollTop = 0;
    })


    this.usaProducts$ = this._homeService.getTopCollections$;
    this.usaProducts$.subscribe(response => {

      if (!response) {
        this._homeService.loadTopCollections().subscribe(data => {
          this.usaProducts = data.filter(f => f.new);

        });
      } else {
        this.usaProducts = response.filter(f => f.new);
      }

    });


  }


  usaProductData() {
    return this._homeService.getSaleProducts$;;
  }




  // Increament
  increment() {
    this.counter++;
  }

  // Decrement
  decrement() {

    if (this.counter == 0) {
      return;
    }
    if (this.counter > 1) this.counter--;
  }

  // Add to cart
  async addToCart(product: IUsaProduct, quantity: number) {



    let isUserLogin = false;
    var user: IUser = JSON.parse(localStorage.getItem('user'));
    if (user || user != null) {
      isUserLogin = true;
    }


    this._authService.getCurrentUser$.subscribe((user: IUser) => {
      if (!user || user == null) {
        isUserLogin = true;
      }
    });


    if (!isUserLogin) {
      this._router.navigate(['/shop/cart'])

      return;
    }

    var isPass = this._homeService.calculateStockCounts(product, this.counter);

    if (!isPass) {
      // this._router.navigate(['/shop/cart'])
      return
    }

    if (quantity == 0) {
      return;
    }

    let cartItem: IAddBaseItem = {
      barcode: product.barcode,
      quantitiesInCartItem: +quantity,
      tableName: "CartItem"

    }

    this._homeService.addBaseItem(cartItem).subscribe({
      next: () => {


        this._router.navigate(['/shop/cart']).then(() => {
          window.location.reload();
        });





      },
      error: () => { },
      complete: () => { console.log('completed') }
    });

  }

  // Buy Now
  async buyNow(product: any) {



    let isUserLogin = false;
    var user: IUser = JSON.parse(localStorage.getItem('user'));
    if (user || user != null) {
      isUserLogin = true;
    }


    this._authService.getCurrentUser$.subscribe((user: IUser) => {
      if (!user || user == null) {
        isUserLogin = true;
      }
    });


    if (!isUserLogin) {
      this._router.navigate(['/shop/cart'])
      return;
    }

    var isPass = this._homeService.calculateStockCounts(product, this.counter);
    if (!isPass) {
      this._router.navigate(['/shop/cart'])
      return
    }


    let cartItem: IAddBaseItem = {
      barcode: product.barcode,
      quantitiesInCartItem: this.counter,
      tableName: "CartItem"

    }

    this._homeService.addBaseItem(cartItem).subscribe({
      next: () => {
        this._router.navigate(['/shop/checkout']);

      },
      error: () => { },
      complete: () => { console.log('completed') }
    });
    // product.quantity = this.counter || 1;
    // const status = await this.productService.addToCart(product);
    // if(status)
    //   this._router.navigate(['/shop/checkout']);

  }

  // Add to Wishlist
  addToWishlist(product: any) {
    this.productService.addToWishlist(product);
  }

  // Toggle Mobile Sidebar
  toggleMobileSidebar() {
    this.mobileSidebar = !this.mobileSidebar;
  }




  isSetWholeSale(value: any) {
    var vv = value;

    return value;
  }

  onTitle(product: IUsaProduct) {
    var result = `${product.category}  >  ${product.subCategory}  >  ${product.subSubCategory}`
    return result;
  }


  // Get Product Color
  colorVariations(productVariation: IProductVariation[]) {

    const uniqColor = [];
    var index = 0;
    for (let i = 0; i < productVariation.length; i++) {
      const element = productVariation[i];
      uniqColor.push(element.childColorName);
    }

    return uniqColor
  }

  onColorClick(activeColor: any, colorWithSizes: IColorWithSize[]) {

    this.uniqSize = [];

    this.colorWithSizes = colorWithSizes;


    for (let i = 0; i < colorWithSizes.length; i++) {
      const element = colorWithSizes[i];
      this.uniqSize.push({
        sizeName: element.sizeName,
        barcode: element.childBarcode,
        color: element.childColorName
      })

    }

    var firstSize = this.uniqSize[0];
    this.selectSize(firstSize);
    return activeColor;
  }


  selectSize(size) {

    this.uniqSize = [];
    //  this._router.navigateByUrl(`/shop/product/left/sidebar/${barcode}`);

    this._homeService.topCollectionById(size.barcode).subscribe({
      next: (respond) => {




        var sizeValue = []
        for (let i = 0; i < respond.productVariations.length; i++) {
          const element = respond.productVariations[i];

          if (element.childColorName == size.color) {
            sizeValue = element.indexProductColorChildrenSizeDtos;
          }
        }


        this.uniqSize = [];
        for (let i = 0; i < sizeValue.length; i++) {
          const element = sizeValue[i];
          this.uniqSize.push({
            sizeName: element.sizeName,
            barcode: element.childBarcode,
            color: element.childColorName
          })
        }
      },
      error: () => { },
      complete: () => { }
    })





    this.selectedSize = size;
    this.currentBarcodeInAddressBar = size.barcode;
  }



  styleObject(activeSlide, i, productVariation): Object {
    if (activeSlide == i) {

      // activeSlide == i.toString() || productVariation.childColorName == 'White' ? 'red' : ''
      // return { background: '#DE3163', opacity: 1 };
      return { 'background-color': productVariation.childColorName, 'border-color': activeSlide == i.toString() ? 'red' : '' }
    }
    else if (productVariation.childColorName == 'White') {
      return { 'background-color': productVariation.childColorName, 'border-color': activeSlide == i.toString() ? 'red' : 'red' }
    } else {
      return { 'background-color': productVariation.childColorName }

    }

    // if (productVariation.childColorName == 'White') {

    //   // activeSlide == i.toString() || productVariation.childColorName == 'White' ? 'red' : ''
    //   // return { background: '#DE3163', opacity: 1 };
    //   return { 'background-color': productVariation.childColorName, 'border-color': activeSlide == i.toString() ? 'red' : '' }
    // }


    return {};
  }

  setStyle(color) {
    if (color == 'White') {
      return { 'border': '1px solid black', 'opacity': 1 }
    }

    return { 'border': '' }

  }


}
